import * as React from 'react';
import { Box } from '@mui/material';
import { connect } from "react-redux";
import ChangePassword from '../LoginPages/ChangePassword';
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption';
import GavelIcon from '@mui/icons-material/Gavel';
import Terms from '../StaticPages/Terms';
import {
  PlatformPage,
  PlatformPageHeader,
  PlatformCard,
  PlatformTabs,
} from '../../app/components/platform';

export const Profile = () => {
  const [tab, setTab] = React.useState('password');

  const tabs = [
    {
      id: 'password',
      label: 'Change password',
      icon: <EnhancedEncryptionIcon sx={{ fontSize: 18 }} />,
    },
    {
      id: 'terms',
      label: 'Terms & conditions',
      icon: <GavelIcon sx={{ fontSize: 18 }} />,
    },
  ];

  return (
    <PlatformPage maxWidth="md">
      <PlatformPageHeader
        title="Partner settings"
        subtitle="Account security and legal information"
      />

      <PlatformCard contentSx={{ pt: 0 }}>
        <PlatformTabs tabs={tabs} value={tab} onChange={setTab} />
        <Box sx={{ px: { xs: 0, sm: 0.5 } }}>
          {tab === 'password' && <ChangePassword embedded />}
          {tab === 'terms' && <Terms />}
        </Box>
      </PlatformCard>
    </PlatformPage>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
